import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '注册登录', path: '/category/register-login' },
  { label: '功能使用', path: '/category/feature-guide' },
  { label: '常见问题', path: '/category/faq' },
  { label: '平台公告', path: '/category/announcement' },
  { label: '安全指南', path: '/category/security' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <h1 className="text-xl font-bold text-foreground-950 font-heading whitespace-nowrap">91n.com</h1>
          <span className="hidden sm:inline text-xs text-foreground-500 border-l border-foreground-300 pl-2 whitespace-nowrap">官方导航</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-1.5 rounded-md text-sm whitespace-nowrap transition-colors ${
                location.pathname === link.path
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <nav className="max-w-[1280px] mx-auto px-4 py-3 flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}